import { render, staticRenderFns } from "./OrganizationHeader.vue?vue&type=template&id=bde6a3de&scoped=true&"
import script from "./OrganizationHeader.vue?vue&type=script&lang=ts&"
export * from "./OrganizationHeader.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationHeader.vue?vue&type=style&index=0&id=bde6a3de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde6a3de",
  null
  
)

export default component.exports